import { customFetch } from "@/client/custom-fetch";
import {
  getProjectPlans,
  getProjectsByOrganization,
} from "@/pages/projects/projects.api";

import {
  TCampaign,
  TCampaignContact,
  TCampaignCreatePayload,
  TCampaignPlanOption,
  TCampaignUpdatePayload,
  TCampaignWhatsappDispatchPayload,
  TCampaignWhatsappDispatchResult,
  TProjectOption,
} from "./campaigns.types";

const API_BASE = "/campaigns";

export interface IListCampaignsParams {
  organization_id?: string;
  project_id?: string;
}

export const listCampaigns = async (
  params?: IListCampaignsParams
): Promise<TCampaign[]> => {
  const search = new URLSearchParams();
  if (params?.organization_id) {
    search.set("organization_id", params.organization_id);
  }
  if (params?.project_id) {
    search.set("project_id", params.project_id);
  }
  const query = search.toString();
  const url = query ? `${API_BASE}?${query}` : API_BASE;
  return customFetch<TCampaign[]>(url);
};

export const getCampaignById = async (id: string): Promise<TCampaign> => {
  return customFetch<TCampaign>(`${API_BASE}/${id}`);
};

export const getCampaignContacts = async (
  campaignId: string
): Promise<TCampaignContact[]> => {
  return customFetch<TCampaignContact[]>(`${API_BASE}/${campaignId}/contacts`);
};

export const createCampaign = async (
  payload: TCampaignCreatePayload
): Promise<TCampaign> => {
  return customFetch<TCampaign>(API_BASE, {
    method: "POST",
    body: JSON.stringify(payload),
  });
};

export const updateCampaign = async (
  id: string,
  payload: TCampaignUpdatePayload
): Promise<TCampaign> => {
  return customFetch<TCampaign>(`${API_BASE}/${id}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
};

export const deleteCampaign = async (id: string): Promise<{ id: string }> => {
  return customFetch<{ id: string }>(`${API_BASE}/${id}`, {
    method: "DELETE",
  });
};

export const dispatchCampaignWhatsappTemplate = async (
  campaignId: string,
  payload: TCampaignWhatsappDispatchPayload
): Promise<TCampaignWhatsappDispatchResult> => {
  return customFetch<TCampaignWhatsappDispatchResult>(
    `${API_BASE}/${campaignId}/whatsapp/dispatch-template`,
    {
      method: "POST",
      body: JSON.stringify(payload),
    }
  );
};

/** Projetos da organização (para select no formulário). */
export const getProjectsByOrg = async (
  organizationId: string
): Promise<TProjectOption[]> => {
  const list = await getProjectsByOrganization(organizationId);
  return list.map((p) => ({
    value: p.project_id,
    label: p.project_name,
  }));
};

/** Planos do projeto (para select múltiplo no formulário). */
export const getPlansByProject = async (
  projectId: string
): Promise<TCampaignPlanOption[]> => {
  const plans = await getProjectPlans(projectId);
  return plans.map((p) => ({ id: p.id, name: p.name }));
};
